(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanSingleSelect', leanSingleSelect);
	
	leanSingleSelect.$inject = ['$timeout', '$filter', 'leanFilterService'];
	function leanSingleSelect($timeout, $filter, leanFilterService) {
		var html = '<div class="single-select-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();">' +
						'<div class="single-select-header">' +
							'<div class="single-select-title"><span translate> {{filterName}}</span></div>' +
							'<div class="single-select-search" ng-click="$event.stopPropagation();">' +
								'<input placeholder="{{\'Search...\'|translate}}" ng-model="$parent.filterSearch" class="filter-menu-search">' +
							'</div>' +
						'</div>' +
						'<div class="single-select-options">' +
							'<ul class="filter-menu">' +
								'<li ng-repeat="item in filterList | filter:$parent.filterSearch" >' +
									'<a class="filterOption flexed" data-testclass="reportFilter-singleSelect-' + '{{filterId}}' + '-option" href ng-click="(!$parent.$parent.filterFunctions.isReadOnly() && $parent.$parent.filterFunctions.toggleItem(item, $parent.filterSearch, true));(!$parent.$parent.filterFunctions.isReadOnly() && $parent.$parent.filterFunctions.applySelection($event, filterId))" ng-disabled="readOnly">' +
										'<i class="fa fa-fw fa-lg fa-circle-thin" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-hide="item.selected"></i>' +
										'<i class="fa fa-fw fa-lg fa-dot-circle-o" ng-class="{\'disabled\': readOnly, \'active\' : !readOnly}" ng-show="item.selected"></i>' +
										'<span class="text-label" ng-bind-html="getItemLabel(item) | translate"></span>' +
										'<span class="individual-exclam" ng-init="popoverOpened[item.id]=false"' + 
											'ng-mouseover="mouseOver(item.id)" ng-mouseleave="mouseLeave(item.id)" ng-click="handleInnerClick($event)">' + 
											'<span ng-show="item.dataSyncIssue"' + 
												'uib-popover-html="getTooltip(item)"' + 
												'popover-class="white-tooltip"' + 
												'popover-placement="right"' +
												'popover-trigger="none"' +
												'popover-is-open="popoverOpened[item.id]"' +
												'popover-popup-close-delay="100"' + 
												'ng-class="{\'hovered\': popoverOpened[item.id]}"' +
												'class="filter-tooltip">' +
												'<i class="fa fa-exclamation-circle"></i>' + 
											'</span></span>' +
									'</a>' +
								'</li>' +
							'</ul>' +
						'</div>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterList: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				var timeoutCanceler = {};
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.popoverOpened = {};
				scope.mouseOver = mouseOver;
				scope.mouseLeave = mouseLeave;
				scope.handleInnerClick = handleInnerClick;
				scope.getTooltip = getTooltip;
				scope.getItemLabel = function(item) {
					var val = scope.$eval(scope.filterLabel, item);
					var formatType = item.formatType;
					var format = item.format;
					if (formatType && format) {
						val = $filter(formatType)(val, format);
					}
					return val;
				};

				function getTooltip(item) {
					return leanFilterService.getDataSyncIssueTooltip(1, 1);
				}

				function mouseOver(siteId) {
					timeoutCanceler[siteId] && $timeout.cancel(timeoutCanceler[siteId]);
					timeoutCanceler[siteId] = $timeout(function () {
						scope.popoverOpened[siteId] = true;
					}, 100);
				};

				function mouseLeave(siteId) {
					timeoutCanceler[siteId] && $timeout.cancel(timeoutCanceler[siteId]);
					timeoutCanceler[siteId] = $timeout(function () {
						scope.popoverOpened[siteId] = false;
					}, 100);
				}

				function mouseLeaveAll() {
					for (var key in timeoutCanceler) {
						mouseLeave(key);
					}
				}

				function handleInnerClick(evt) {
					evt.stopPropagation();
					if (evt.target.className && 
						(evt.target.className.indexOf('tooltip-close') >= 0
							|| evt.target.className.indexOf('fa-times') >= 0)) {
						mouseLeaveAll();
					}
				}

			}
		};
	}
})();
